import styled from 'styled-components';

export const ToggleContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 8px;
  width: 100%;
`;

export const ToggleOption = styled.div`
  flex: 1 1 200px;
  min-width: 200px;
`;

export const ToggleButton = styled.button`
  padding: 12px 20px 12px 44px;
  border: 2px solid ${({ $active }) => ($active ? '#be1622' : '#d3d3d3')};
  background: ${({ $active }) => ($active ? '#fff5f6' : '#fff')};
  color: ${({ $active }) => ($active ? '#be1622' : '#333')};
  border-radius: 12px;
  font-size: 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &:hover {
    background: ${({ disabled, $active }) => !disabled && !$active && '#f9f9f9'};
  }
`;

export const Checkmark = styled.span`
  display: inline-flex;
  position: absolute;
  left: 12px;
  width: 24px;
  height: 24px;
  background-color: ${({ $active }) => ($active ? '#be1622' : '#d3d3d3')};
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  align-items: center;
  justify-content: center;
`;

export const ToggleContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const ToggleTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
`;

export const ToggleDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 4px 0 0 0;
  line-height: 1.4;
`;
